import {EntityField} from "../../../core/genericdocuments/EntityField";
import {EntityFieldDataType} from "../../../core/genericdocuments/EntityFieldDataType";
import {EntityFieldsDescriptor} from "../../../core/genericdocuments/EntityFieldsDescriptor";
import {baseDocumentFields} from "../BaseDocumentFields";
import {LookupEntities} from "../../../core/genericdocuments/ReferenceDetails";
import {PonudaDocument} from "./PonudaDocument";

// obavezno: datum zavodjenja, delovodni broj, datum dokumenta, broj dokumenta, tip ponude, partner, sektor
// opciono: opis, lista priloga
export const ponudaDocumentFields: IntercateKeysMap<PonudaDocument, EntityField<PonudaDocument>> = {
	...baseDocumentFields,
	clientId: {
		name: "clientId", dataType: EntityFieldDataType._reference, label: "Partner",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Customers
		},
		validator: { required: true },
		sortable: true,
		autocomplete: true
	},
	cooperationType: {
		name: "cooperationType", dataType: EntityFieldDataType._string, label: "Tip ponude",
		validator: { required: true },
		sortable: true
	},
	parentId: {
		name: "parentId", dataType: EntityFieldDataType._derived, label: "Parent",
		value: (item: { clientId: any; }) => item.clientId,
		hide: formState => true
	}
}

const documentFieldsArray: Array<EntityField<PonudaDocument>> = [
	ponudaDocumentFields.indexingNumber,
	ponudaDocumentFields.indexingDate,
	ponudaDocumentFields.documentNumber,
	ponudaDocumentFields.documentDate,
	ponudaDocumentFields.assignedTo,
	ponudaDocumentFields.clientId,
	ponudaDocumentFields.sectorId,
	ponudaDocumentFields.cooperationType,
	ponudaDocumentFields.tags,
	ponudaDocumentFields.parentId
]

export const ponudaDocumentFieldsDescriptor: EntityFieldsDescriptor<PonudaDocument> = {
	listFields: documentFieldsArray,
	createFormFields: documentFieldsArray,
	updateFormFields: documentFieldsArray
}
